import { EP_GET_AC_TOKEN } from '../constants/endPointConstants';
import api from './Api';

const getAgoraToken = async (roomId, playerId, publish = false) => {
    const response = await api.get(`${EP_GET_AC_TOKEN}/${roomId}/${playerId}`, { params: { publish } });
    return response.data;
}

export {getAgoraToken}
